import { z } from 'zod'

export const S3Usage = z.object({
  storage_bytes: z.number(),
  egress_bytes: z.number(),
  request_count: z.number(),
  bucket_count: z.number()
})
export type S3Usage = z.infer<typeof S3Usage>
